export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '86af7379-484a-4d0f-934c-b7614c44a4f6';
export const MODAL_CLOSE_SEC = 2.5;